$(document).ready(function() {
    var $stickyDiv = $('#FacetsWrapperDesktop');
    var $stickyContainer = $stickyDiv.parent('.facets__form ');
    var $targetDiv = $('#ProductGridContainer');

    var stickyDivOriginalTop = $stickyDiv.offset().top;
    var stickyDivHeight = $stickyDiv.outerHeight();

    var parentWidth;
    var parentOffsetLeft;

    function updateParentProperties() {
        parentWidth = $stickyContainer.width();
        parentOffsetLeft = $stickyContainer.offset().left;
    }

    updateParentProperties();

    function handleSticky() {
        var scrollTop = $(window).scrollTop();
        var targetDivBottom = $targetDiv.offset().top + $targetDiv.outerHeight();
        var stickyDivEndLimit = targetDivBottom - stickyDivHeight;

        if (scrollTop > stickyDivOriginalTop) {
            if (scrollTop < stickyDivEndLimit) {
                $stickyDiv.css({
                    position: 'fixed',
                    top: '0px',
                    background: 'white',
                    width: parentWidth + 'px',
                    left: parentOffsetLeft + 'px'
                });
            } else {
                $stickyDiv.css({
                    position: 'absolute',
                    top: (targetDivBottom - stickyDivOriginalTop - stickyDivHeight) + 'px',
                    width: '100%',
                    left: '0px'
                });
            }
        } else {
            $stickyDiv.css({
                position: 'relative',
                top: '0px',
                width: '100%',
                left: '0px'
            });
        }
    }

    $(window).on('scroll', handleSticky);

    $(window).on('resize', function() {
        updateParentProperties();
        stickyDivOriginalTop = $stickyDiv.offset().top;
        handleSticky();
    });

    handleSticky();
});